import './Navbar.css';

const Navbar = () => {

    return (

        <div className="navbar">

            <div className="search-box">

                <input
                    type="text"
                    placeholder="Search..."
                />

            </div>


            <div className="nav-right">

                <div className="notification">

                    🔔

                </div>


                <div className="profile">

                    L

                </div>

            </div>

        </div>

    );
}

export default Navbar;